import axios from "axios";
import Statics from "@/components/common/Statics";


const state = {
    login: {
        logged_in: false,
        token: localStorage.getItem('token'),
        loading: false,
        status: '',
        error: {},
    },
    register: {
        phone: '',
        verification_token: "",
        loading: false,
        error: {},
        data: {},
    },
    profile: {
        "has_team": true,
        "user": {
            "id": 2,
            "phone": "09122022254",
            "last_login": "2023-08-23T18:52:51.178015Z",
            "is_superuser": false,
            "first_name": "elaheeeee",
            "last_name": "shooojaee",
            "is_staff": false,
            "is_active": true,
            "date_joined": "2023-08-20T09:23:52.804668Z",
            "is_verified": true,
            "image": "/media/profile_pics/default.jpg",
            "team": 1,
            "groups": [],
            "user_permissions": []
        },
        "is_owner": true,
        "team": {
            "id": 1,
            "members": [
                {
                    "id": 2,
                    "phone": "09122022254",
                    "last_login": "2023-08-23T18:52:51.178015Z",
                    "is_superuser": false,
                    "first_name": "elaheeeee",
                    "last_name": "shooojaee",
                    "is_staff": false,
                    "is_active": true,
                    "date_joined": "2023-08-20T09:23:52.804668Z",
                    "is_verified": true,
                    "image": "/media/%2B989122022254.jpg",
                    "team": 1,
                    "groups": [],
                    "user_permissions": []
                }
            ],
            "name": "foz",
            "balance": 250.0,
            "owner": 2
        }
    },
    invitations: {
        sent: [],
        received: []
    },
    orders: [],
    dialogs: {
        edit_profile: {
            birth_year: null,
            email: null,
            first_name: null,
            grade: null,
            image: null,
            last_name: null,
            major: null,
            organization: null,
            phone: null,
            show: false,
        },
        create_team: {
            name: null,
            image: null,
            show: false
        },
        edit_team: {
            title: null,
            show: false,
            image_changed: false
        },
        send_invitation: {
            phone: null,
            show: false,
        }
    }

}
const mutations = {
    login_success(state, payload) {
        localStorage.setItem('token', payload.token)
        state.login.loading = false
        state.login.token = payload.token;
        state.login.status = 'success'
        state.login.logged_in = true
    },
    get_profile_success(state, payload) {
        state.profile = payload
    },
    edit_profile_success(state, payload) {
        this.commit('show_snackbar', {
            text: 'اطلاعات با موفقیت به روزرسانی شدند',
            type: 1
        })
    },


    // team management
    open_create_team_dialog(state, payload) {
        state.dialogs.create_team = {
            show: true,
            name: null,
            english_name: null,
            organization: null,
            slogan: null,
            image: null,
        }
    },
    close_create_team_dialog(state, payload) {
        state.dialogs.create_team.show = false
    },
    create_team_success(state, payload) {

    },
    create_team_error(state, payload) {

    },
    open_edit_profile_dialog(state, payload) {
        state.dialogs.edit_profile = {
            birth_year: state.profile.user.birth_year,
            email: state.profile.user.email,
            first_name: state.profile.user.first_name,
            grade: state.profile.user.grade,
            image: state.profile.user.image,
            last_name: state.profile.user.last_name,
            major: state.profile.user.major,
            organization: state.profile.user.organization,
            phone: state.profile.user.phone,
            show: true,
        }
    },
    close_edit_profile_dialog(state, payload) {
        state.dialogs.edit_profile = {
            birth_year: null,
            email: null,
            first_name: null,
            grade: null,
            image: null,
            last_name: null,
            major: null,
            organization: null,
            phone: null,
            show: false,
        }
    },
    open_edit_team_dialog(state, payload) {
        state.dialogs.edit_team = {...state.profile.team, show: true, image_changed: false}

    },
    close_edit_team_dialog(state, payload) {
        state.dialogs.edit_team.show = false
    },


    open_send_invitation_dialog(state, payload) {
        state.dialogs.send_invitation.show = true
        state.dialogs.send_invitation.phone = null
    },
    close_send_invitation_dialog(state, payload) {
        state.dialogs.send_invitation.show = false
    },
    send_invitation_error(state, payload) {
        // this.commit('show_snackbar', {
        //     text: Statics.invitation_errors[payload.error.response.data.error_code].text,
        //     type: 1
        // })
    },

    get_sent_invitations_success(state, payload) {
        state.invitations.sent = payload.reverse()
    },
    success_delete_sent_invitation(state, payload) {
        this.commit('show_snackbar', {
            text: 'دعوت با موفقیت حذف شد',
            type: 1
        })
    },
    success_accept_received_invitation(state, payload) {
        this.commit('show_snackbar', {
            text: 'دعوت با موفقیت پذیرفته شد',
            type: 1
        })
    },
    success_decline_received_invitation(state, payload) {
        this.commit('show_snackbar', {
            text: 'دعوت با موفقیت رد شد',
            type: 1
        })
    },
    success_leave_team(state, payload) {
        this.commit('show_snackbar', {
            text: 'شما از تیم خود با موفقیت خارج شدید',
            type: 1
        })
    },
    success_delete_team(state, payload) {
        this.commit('show_snackbar', {
            text: 'ایمیل حذف تیم با موفقیت به شما ارسال شد.',
            type: 1
        })
    },
    success_send_verification_email(state, payload) {
        this.commit('show_snackbar', {
            text: 'ایمیل تایید به شما مجددا ارسال شد.',
            type: 1
        })
    },
    get_received_invitations_success(state, payload) {
        state.invitations.received = payload.reverse()
    },


}

const actions = {
    send_code_for_password_change({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'post',
                url: this.state.base_api + 'auth/verify/send/login/',
                data: {
                    phone: payload.phone
                }
            }
            axios(config)
                .then(function (response) {
                    commit('show_snackbar', {text: 'کد با موفقیت ارسال شد', type: 1})
                    resolve(response.data)
                })
                .catch(function (err) {
                    // commit('show_snackbar', {
                    //     text: 'مشکلی در ارسال اطلاعات وجود دارد، لطفا مجددا تلاش کنید.',
                    //     type: 2
                    // })
                    reject(err)
                });

        })
    },
    token_login({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'post',
                url: this.state.base_api + 'auth/login/token/',
                data: {
                    phone: payload.phone,
                    code: payload.code
                }
            };
            axios(config)
                .then(function (response) {
                    commit('show_snackbar', {text: 'کد با موفقیت تایید شد', type: 1})
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('show_snackbar', {text: 'کد وارد شده صحیح نمیباشد، لطفا مجددا تلاش کنید', type: 2})
                    reject(err)
                });
        })
    },
    send_code_for_register({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'post',
                url: this.state.base_api + 'auth/verify/send/register/',
                data: {
                    phone: payload.phone
                }
            }
            axios(config)
                .then(function (response) {
                    commit('show_snackbar', {text: 'کد با موفقیت ارسال شد', type: 1})
                    resolve(response.data)
                })
                .catch(function (err) {
                    // commit('show_snackbar', {
                    //     text: 'مشکلی در ارسال اطلاعات وجود دارد، لطفا مجددا تلاش کنید.',
                    //     type: 2
                    // })
                    reject(err)
                });

        })
    },
    check_code_for_register({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'post',
                url: this.state.base_api + 'auth/verify/check/',
                data: {
                    phone: payload.phone,
                    code: payload.code
                }
            };
            axios(config)
                .then(function (response) {
                    commit('show_snackbar', {text: 'کد با موفقیت تایید شد', type: 1})
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('show_snackbar', {text: 'کد وارد شده صحیح نمیباشد، لطفا مجددا تلاش کنید', type: 2})
                    reject(err)
                });
        })
    },
    register({commit}, payload) {
        return new Promise((resolve, reject) => {
            let data = new FormData();
            data.append('phone', payload.phone);
            data.append('verification_token', payload.verification_token)
            data.append('first_name', payload.first_name);
            data.append('last_name', payload.last_name);
            data.append('birth_year', payload.birth_year);
            data.append('organization', payload.organization);
            data.append('grade', payload.grade);
            data.append('email', payload.email);
            data.append('major', payload.major);
            data.append('password', payload.pass);
            data.append('confirm_password', payload.repass);
            if (payload.image !== null) {
                data.append('image', payload.image)
            }
            this.loading = true
            let config = {
                method: 'post',
                url: this.state.base_api + 'auth/register/',
                data: data
            };
            axios(config)
                .then(function (response) {
                    // commit('registering_success', response)
                    commit('show_snackbar', {text: 'ثبت نام با موفقیت انجام شد.', type: 1})

                    resolve(response.data)
                })
                .catch(function (err) {
                    // commit('registering_error', {error: err})
                    let text = "ثبت نام شما ناموفق بود، لطفا مجددا تلاش کنید"
                    if (err.response.data.email)
                        text = "این ایمیل قبلا ثبت شده است."
                    commit('show_snackbar', {text: text, type: 2})
                    reject(err)
                });
        })
    },
    change_password({commit}, payload) {
        return new Promise((resolve, reject) => {
            let data = new FormData();
            // data.append('phone', payload.phone);
            // data.append('verification_token', payload.verification_token)
            data.append('password', payload.pass);
            data.append('confirm_password', payload.repass);
            this.loading = true
            let config = {
                method: 'post',
                url: this.state.base_api + 'auth/reset-password/',
                data: data,
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                },
            };
            axios(config)
                .then(function (response) {
                    // commit('registering_success', response)
                    commit('show_snackbar', {text: 'تغییر رمز با موفقیت انجام شد.', type: 1})

                    resolve(response.data)
                })
                .catch(function (err) {
                    // commit('registering_error', {error: err})
                    commit('show_snackbar', {text: 'تغییر رمز شما ناموفق بود، لطفا مجددا تلاش کنید', type: 2})
                    reject(err)
                });
        })
    },
    login({commit}, payload) {
        return new Promise((resolve, reject) => {
            let data = new FormData();
            let config = {
                method: 'post',
                url: this.state.base_api + 'auth/login/',
                data: {
                    phone: payload.phone,
                    password: payload.password
                }
            };
            return axios(config)
                .then(function (response) {
                    commit('login_success', response.data)
                    commit('show_snackbar', {text: 'ورود با موفقیت', type: 1})
                    resolve(response.data);
                })
                .catch(function (err) {
                    commit('show_snackbar', {text: 'ورود ناموق، رمز و شماره خود را چک کنید', type: 2})
                    reject(err);
                })
        })
    },
    get_profile({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'get',
                url: this.state.base_api + 'auth/profile/',
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                }
            };
            return axios(config)
                .then(function (response) {
                    commit('get_profile_success', response.data)
                    resolve(response.data);
                })
                .catch(function (err) {
                    reject(err);
                })
        })
    },
    update_profile({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'put',
                url: this.state.base_api + 'auth/profile/',
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                },
                data: payload
            };
            return axios(config)
                .then(function (response) {
                    commit('edit_profile_success', response.data)
                    resolve(response.data);
                })
                .catch(function (err) {
                    let text = "خطا در ارتباط با سرور"
                    if (err.response.data.email)
                        text = "این ایمیل قبلا ثبت شده است."
                    commit('show_snackbar', {text: text, type: 2})
                    reject(err);
                })
        })
    },


    create_team({commit}, payload) {
        return new Promise((resolve, reject) => {
            let values = state.dialogs.create_team
            let data = new FormData();
            data.append('name', values.name);
            data.append('english_name', values.english_name);
            data.append('image', values.image);
            data.append('slogan', values.slogan);
            data.append('organization', values.organization);
            this.loading = true
            let config = {
                method: 'post',
                url: this.state.base_api + 'auth/create-team/',
                data: data
                ,
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                }
            };
            axios(config)
                .then(function (response) {
                    commit('create_team_success', response)
                    commit('show_snackbar', {text: 'ساخت تیم با موفقیت انجام شد.', type: 1})

                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('create_team_error', {error: err})
                    commit('show_snackbar', {text: 'ساخت تیم ناموفق بود، لطفا مجددا تلاش کنید', type: 2})
                    reject(err)
                });
        })
    },
    update_team({commit}, payload) {
        return new Promise((resolve, reject) => {
            let values = state.dialogs.edit_team
            let data = new FormData();
            data.append('name', values.name);
            data.append('english_name', values.english_name);
            if (values.image_changed)
                data.append('image', values.image);
            data.append('slogan', values.slogan);
            data.append('organization', values.organization);
            this.loading = true
            let config = {
                method: 'put',
                url: this.state.base_api + 'auth/update-team/',
                data: data,
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                }
            };
            axios(config)
                .then(function (response) {
                    commit('create_team_success', response)
                    commit('show_snackbar', {text: 'به روزرسانی تیم با موفقیت انجام شد', type: 1})

                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('create_team_error', {error: err})
                    commit('show_snackbar', {text: ' ناموفق بود، لطفا مجددا تلاش کنید', type: 2})
                    reject(err)
                });
        })
    },
    search_phone({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'get',
                url: this.state.base_api + 'auth/search-user/' + '?phone=' + payload.search_query,
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                },
            };
            axios(config)
                .then(function (response) {
                    // commit('search_symbol_success', response.data)
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('show_snackbar', {text: 'خطا در اتصال به سرور', type: 2})
                    reject(err)
                });
        })
    },
    send_invitation({commit}, payload) {
        return new Promise((resolve, reject) => {
            this.loading = true
            let config = {
                method: 'post',
                url: this.state.base_api + 'auth/invite/',
                data: {
                    phone: state.dialogs.send_invitation.phone
                },
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                }
            };
            axios(config)
                .then(function (response) {
                    commit('show_snackbar', {text: 'دعوت با موفقیت انجام شد', type: 1})
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('send_invitation_error', {error: err})
                    reject(err)

                });
        })
    },
    get_sent_invitations({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'get',
                url: this.state.base_api + 'auth/sent-invitations/',
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                },
            };
            axios(config)
                .then(function (response) {
                    commit('get_sent_invitations_success', response.data)
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('show_snackbar', {text: 'خطا در اتصال به سرور', type: 2})
                    reject(err)
                });
        })
    },
    delete_sent_invitation({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'post',
                url: this.state.base_api + 'auth/delete-invitation/',
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                },
                data: {
                    id: payload.id
                }
            };
            axios(config)
                .then(function (response) {
                    commit('success_delete_sent_invitation')
                    resolve(response.data)
                })
                .catch(function (err) {
                    reject(err)
                });
        })
    },
    get_received_invitations({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'get',
                url: this.state.base_api + 'auth/received-invitations/',
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                },
            };
            axios(config)
                .then(function (response) {
                    commit('get_received_invitations_success', response.data)
                    resolve(response.data)
                })
                .catch(function (err) {
                    commit('show_snackbar', {text: 'خطا در اتصال به سرور', type: 2})
                    reject(err)
                });
        })
    },
    accept_received_invitation({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'post',
                url: this.state.base_api + 'auth/accept/',
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                },
                data: {
                    id: payload.id
                }
            };
            axios(config)
                .then(function (response) {
                    commit('success_accept_received_invitation')
                    resolve(response.data)
                })
                .catch(function (err) {
                    reject(err)
                });
        })
    },
    decline_received_invitation({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'post',
                url: this.state.base_api + 'auth/decline/',
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                },
                data: {
                    id: payload.id
                }
            };
            axios(config)
                .then(function (response) {
                    commit('success_decline_received_invitation')
                    resolve(response.data)
                })
                .catch(function (err) {
                    reject(err)
                });
        })
    },
    leave_team({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'delete',
                url: this.state.base_api + 'auth/leave/',
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                },

            };
            axios(config)
                .then(function (response) {
                    commit('success_leave_team')
                    resolve(response.data)
                })
                .catch(function (err) {
                    reject(err)
                });
        })
    },
    remove_member({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'delete',
                url: this.state.base_api + 'auth/remove-member/',
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                },
                data: {
                    id: payload.id
                }

            };
            axios(config)
                .then(function (response) {
                    commit('success_remove_member')
                    resolve(response.data)
                })
                .catch(function (err) {
                    reject(err)
                });
        })
    },
    delete_team({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'post',
                url: this.state.base_api + 'auth/send-delete-team-confirmation-email/',
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                },

            };
            axios(config)
                .then(function (response) {
                    commit('success_delete_team')
                    resolve(response.data)
                })
                .catch(function (err) {
                    reject(err)
                });
        })
    },
    send_verification_email({commit}, payload) {
        return new Promise((resolve, reject) => {
            let config = {
                method: 'post',
                url: this.state.base_api + 'auth/send-verification-email/',
                headers: {
                    Authorization: "token " + localStorage.getItem("token"),
                },
            };
            axios(config)
                .then(function (response) {
                    commit('success_send_verification_email')
                    resolve(response.data)
                })
                .catch(function (err) {
                    reject(err)
                });
        })
    },

}

export default {
    state,
    actions,
    mutations,
}